<app-sticky-nav-top
  [displayLocalMissionSecureSpace]="displayLocalMissionSecureSpace$ | async"
  [displayCompanySecureSpace]="displayCompanySecureSpace$ | async"
  [menuOpen]="menuOpen$ | async"
  [triggerAnimOut]="triggerAnimOut$ | async"
  [companyId]="companyId$ | async"
  [eventId]="eventId$ | async"
  (closeMobileMenu)="closeMobileMenu()"
  (logoutFromSecuredSpace)="logoutFromSecuredSpace()"
  (openMobileMenu)="openMobileMenu()"
></app-sticky-nav-top>

<!-- Desktop Menu Items -->
<nav *ngIf="(isWeb$ | async) === true" class="nav nav__links" aria-label="un jeune une solution">
  <ul
    class="nav__list"
    [class.nav__list--separator]="(hideHeaderBorder$ | async) === false"
    role="menubar"
    aria-label="menu de navigation"
  >
    <li>
      <a
        [routerLink]="['/']"
        ignoreExternLink
        aria-label="Page d'Accueil"
        class="homepage-link"
        (click)="trackEvent({ category: 'Navigation', action: 'Click Accueil', label: 'Maison', type: 'navigation' })"
      >
        <mat-icon svgIcon="home" role="presentation"></mat-icon>
      </a>
    </li>
    <li class="nav-item" role="none" *ngFor="let navItem of MENU; trackBy: trackByIndex">
      <app-dropdown-nav *ngIf="navItem.dropdownItems?.length" [dropdownNav]="navItem"></app-dropdown-nav>
      <a
        *ngIf="!navItem.dropdownItems"
        role="menuitem"
        class="nav-link"
        [routerLink]="navItem.link"
        routerLinkActive="nav-link--active"
        (click)="
          trackEvent({
            category: 'Navigation',
            action: navItem.trackEventAction,
            label: 'Titre',
            type: 'navigation'
          })
        "
        [attr.aria-label]="navItem.ariaLabel"
      >
        {{ navItem.label }}
      </a>
    </li>
  </ul>
</nav>

<!-- Mobile Menu Items -->
<nav
  *ngIf="(menuOpen$ | async) === true"
  class="nav nav--open"
  [@fadeInLeftOnEnter]
  [@fadeOutLeft]="(triggerAnimOut$ | async) === true"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  appPressEscapeKey
  (pressEscapeKey)="closeMobileMenu()"
>
  <div class="close">
    <button type="button" mat-icon-button (click)="closeMobileMenu()" aria-label="Fermer le menu">
      <mat-icon svgIcon="close" role="presentation"></mat-icon>
    </button>
  </div>

  <ul
    class="nav__list"
    [class.nav__list--separator]="(hideHeaderBorder$ | async) === false"
    aria-label="Liens de navigations"
  >
    <li routerLinkActive="nav-item-active" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
      <a
        role="menuitem"
        class="nav-link nav-link-main"
        [routerLink]="['/']"
        ignoreExternLink
        (click)="
          closeMobileMenu();
          trackEvent({ category: 'Navigation', action: 'Click Accueil', label: 'Titre', type: 'navigation' })
        "
      >
        Accueil
      </a>
    </li>

    <li *ngFor="let navItem of MENU; trackBy: trackByIndex" routerLinkActive="nav-item-active" class="nav-item">
      <ng-container *ngIf="!navItem.dropdownItems">
        <a
          class="nav-link nav-link-main"
          [routerLink]="navItem.link"
          (click)="
            closeMobileMenu();
            trackEvent({
              category: 'Navigation',
              action: navItem.trackEventAction,
              label: 'Titre',
              type: 'navigation'
            })
          "
          [attr.aria-label]="navItem.ariaLabel"
        >
          {{ navItem.label }}
        </a>
      </ng-container>
      <ng-container *ngIf="navItem.dropdownItems?.length">
        <a
          class="nav-link nav-link-main"
          [routerLink]="navItem.link"
          (click)="
            closeMobileMenu();
            trackEvent({
              category: 'Navigation',
              action: navItem.trackEventAction,
              label: 'Titre',
              type: 'navigation'
            })
          "
          [attr.aria-label]="navItem.ariaLabel"
        >
          {{ navItem.label }}
        </a>
        <ul class="nav-sublist">
          <li *ngFor="let navMenuItem of navItem.dropdownItems; trackBy: trackByLabel">
            <a
              class="nav-link"
              [routerLink]="navMenuItem.link"
              [queryParams]="navMenuItem.queryParams"
              routerLinkActive="nav-link--active"
              #rla="routerLinkActive"
              [attr.aria-label]="navMenuItem.ariaLabel"
              (click)="
                closeMobileMenu();
                trackEvent({ category: 'Navigation', action: navMenuItem.trackEventAction, type: 'navigation' })
              "
            >
              <mat-icon
                *ngIf="rla.isActive"
                role="presentation"
                class="nav-sublist__icon"
                svgIcon="chevron_right"
              ></mat-icon>
              {{ navMenuItem.label }}</a
            >
          </li>
        </ul>
      </ng-container>
    </li>
  </ul>
</nav>
